/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import { myIntegrationColumns } from 'src/core/table-columns'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { CustomCard, CustomTable, DevelopersListHeader } from 'src/components'
import { getUserIntegrationList, selectCurrencyToken, userIntegrationListSelector } from 'src/features'


const DevelopersMyIntegrationList: React.FC = () => {
  const { loading, filtered } = useAppSelector(userIntegrationListSelector)

  const dispatch = useAppDispatch()
  const currency = useAppSelector(selectCurrencyToken)

  useEffect(() => {
    dispatch(getUserIntegrationList(currency))
  }, [dispatch, currency])

  return (
    <CustomCard loading={loading} className={'mt-4'} >
      <DevelopersListHeader quantity={filtered.length}/>
      <CustomTable
        columns={myIntegrationColumns}
        dataSource={filtered}
      />
    </CustomCard>
  )
}

export default DevelopersMyIntegrationList
